import { getConnection } from "@/utils/config/connection"
import { DEBUG_MODE, getProgramId } from "@/utils/constants"
import {
  BlockchainNetwork,
  PoolType,
  ReserveType,
  fetchPoolMetadata,
  fetchPools,
} from "@renec-foundation/relend-adapter/index"
import BigNumber from "bignumber.js"

export const getTotalValues = (selectedPool: PoolType) => {
  const totalSupplyUsd =
    selectedPool?.reserves.reduce((arr, r) => BigNumber(r.totalSupplyUsd).plus(arr), BigNumber(0)) ?? new BigNumber(0)
  const totalBorrowUsd =
    selectedPool?.reserves.reduce((arr, r) => BigNumber(r.totalBorrowUsd).plus(arr), BigNumber(0)) ?? new BigNumber(0)
  const totalAvailableUsd =
    selectedPool?.reserves.reduce((arr, r) => BigNumber(r.availableAmountUsd).plus(arr), BigNumber(0)) ??
    new BigNumber(0)

  return {
    totalBorrowUsd: totalBorrowUsd.toString(),
    totalSupplyUsd: totalSupplyUsd.toString(),
    totalAvailableUsd: totalAvailableUsd.toString(),
    totalMarket: totalSupplyUsd.plus(totalBorrowUsd).toString(),
  }
}

export const getPoolValues = async (network: BlockchainNetwork) => {
  const connection = getConnection(network)
  const programId = getProgramId(network)
  const result = await fetchPoolMetadata(network, connection, true, DEBUG_MODE)
  const defaultPools = Object.fromEntries(
    result.map((pool) => [
      pool.address,
      {
        name: pool.name,
        authorityAddress: pool.authorityAddress,
        address: pool.address,
        owner: pool.owner,
        reserves: [] as Array<ReserveType>,
      },
    ]),
  )
  const currentSlot = await connection.getSlot()
  const poolsResult = await fetchPools(
    network,
    Object.values(defaultPools),
    connection,
    programId,
    currentSlot,
    DEBUG_MODE,
  )
  const parsedPools = Object.keys(poolsResult).map((address) => {
    const pool = poolsResult[address]
    return {
      ...pool,
      reserves: pool.reserves.map((r) => ({
        ...r,
        accumulatedProtocolFeesWad: r.accumulatedProtocolFeesWad.toString(),
        totalBorrowWad: r.totalBorrowWad.toString(),
        availableAmountWad: r.availableAmountWad.toString(),
        mintTotalSupplyWad: r.mintTotalSupplyWad.toString(),
        addedBorrowWeightBPS: r.addedBorrowWeightBPS.toString(),
        lastUpdateSlot: r.lastUpdateSlot.toString(),
      })),
    }
  })

  return JSON.stringify(parsedPools)
}
